module.exports = __webpack_public_path__ + "img/奸笑.706dbee3.png";